<template>
    <div class="col-12 col-md-5 offset-md-1">
        <div class="form-group">
            <label for="medicare-part-a-effective-date"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="getDate">
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        name="medicare-part-a-effective-date"
                        class="form-control"
                        :value="formatDateInput(payer.MedicarePartAEffectiveDate)"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group">
            <label for="coinsurance-amount"> Coinsurance Amount </label>
            <input
                class="form-control"
                maxlength="50"
                name="coinsurance-amount"
                type="text"
                placeholder="Enter Coinsurance Amount"
                v-model="payer.CoinsuranceAmount"
            />
        </div>
        <div class="form-group">
            <label for="has-deductible-met"> Prior Authorization Required </label>
            <div>
                <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                    <label
                        :class="`btn btn-outline-secondary ${payer.RequirePriorAuthorization ? 'active' : ''}`"
                        @click="requireAuthorizationChanged(true)"
                    >
                        <input type="radio" hidden name="require-authorization" autocomplete="off" /> Yes
                    </label>
                    <label
                        :class="`btn btn-outline-secondary ${payer.RequirePriorAuthorization ? '' : 'active'}`"
                        @click="requireAuthorizationChanged(false)"
                    >
                        <input type="radio" hidden name="require-authorization" autocomplete="off" /> No
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-md-5">
        <div class="form-group">
            <label for="out-of-pocket-amount"> Out-of-Pocket Maximum Amount </label>
            <input
                class="form-control"
                maxlength="50"
                name="out-of-pocket-amount"
                type="text"
                placeholder="Enter Out-of-Pocket Maximum Amount"
                v-model="payer.OutOfPocketMaxAmount"
            />
        </div>
        <div class="form-group">
            <label for="out-of-pocket-met"> Out-of-Pocket Maximum Met </label>
            <div>
                <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                    <label
                        :class="`btn btn-outline-secondary ${payer.IsOutOfPocketMaxMet ? 'active' : ''}`"
                        @click="outOfPocketMaxMetChanged(true)"
                    >
                        <input type="radio" hidden name="out-of-pocket-met" autocomplete="off" /> Yes
                    </label>
                    <label
                        :class="`btn btn-outline-secondary ${payer.isOutOfPocketMaxMet ? '' : 'active'}`"
                        @click="outOfPocketMaxMetChanged(false)"
                    >
                        <input type="radio" hidden name="out-of-pocket-met" autocomplete="off" /> No
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { formatDateInput } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { PatientPayor } from "../../../../../../../resources-vue/vue-models/patient-payor";

import DatePicker from "../../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    components: {
        DatePicker
    },
    props: {
        payer: {
            type: Object
        },
        requireAuthorizationChanged: {
            type: Function
        },
        outOfPocketMaxMetChanged: {
            type: Function
        },
        getDate: {
            type: Function
        }
    },
    data() {
        return {
            formatDateInput
        };
    }
});
</script>
